import React from 'react';
import './style.scss';
import { PlaidLink } from 'react-plaid-link';
import { Spin } from 'antd';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '@share/components';

interface PlaidState {
  isPlaidToken: boolean;
  isLoading: boolean;
  linkToken: string;
  expiration: string;
  requestID: string;
}

interface BankDetails {
  bankName: string;
  lastFourDigits: string;
  bankType: string;
}

interface CompanyPlaidComponentProps {
  plaidState: PlaidState;
  totalPending: number;
  bankName: BankDetails[];
  selectedBank: {} | null;
  isBankLoading: boolean;
  handleAddMoreBanks: () => void;
  handleProceed: () => void;
  handlePlaidSuccess: (publicToken: string, metadata: any) => void;
  handlePlaidExit: (error: any, metadata: any) => void;
  handleBankSelection: (e: React.ChangeEvent<HTMLInputElement>, bank: any) => void;
}

const CompanyPlaidComponent: React.FC<CompanyPlaidComponentProps> = ({
  plaidState,
  bankName,
  selectedBank,
  handlePlaidSuccess,
  handlePlaidExit,
  handleAddMoreBanks,
  handleProceed,
  handleBankSelection,
  isBankLoading,
  totalPending
}) => {
  return (
    <>
      <Spin spinning={isBankLoading} className="d-flex align-items-center justify-content-center">
        <div className="accountDetail">
          <div className="accountDetail_payment d-flex align-items-center w-100">
            <div className="accountDetail_usd accountDetail_item fw-bold">USD</div>
            <div className="accountDetail_price accountDetail_item fw-bold">
              <span>{totalPending}</span>
            </div>
          </div>
          <div className="linkAccount">
            {bankName.length > 0 && (
              <div className="linkAccount_item d-flex align-items-center justify-content-between">
                <h2 className="mb-0">Link a Bank Account</h2>
                <PlaidLink
                  token={plaidState.linkToken}
                  onSuccess={handlePlaidSuccess}
                  onExit={handlePlaidExit}
                  className="addMore"
                >
                  <span onClick={handleAddMoreBanks}>
                    <FormattedMessage id="add.more.bank" />
                  </span>
                </PlaidLink>
              </div>
            )}
            {bankName.map((bank, index) => (
              <div
                key={index}
                className="linkAccount_bankList d-flex align-items-center justify-content-between"
              >
                <div className="form-check d-flex align-items-center">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="flexRadioDefault"
                    id={`flexRadioDefault${index}`}
                    // checked={selectedBank?.bankName === bank.bankName}
                    onChange={(e) => handleBankSelection(e, bank)}
                  />
                  <label className="form-check-label" htmlFor={`flexRadioDefault${index}`}>
                    <div className="name text-uppercase">{bank.bankName}</div>
                    <div className="details">
                      {bank.bankType} - **** {bank.lastFourDigits}
                    </div>
                  </label>
                </div>
                <em className="bi bi-bank" />
              </div>
            ))}
            {bankName.length > 0 ? (
              <div className="btnAction mt-4">
                <button
                  className="btn btn-primary rounded-pill btn-lg w-100"
                  disabled={!selectedBank || selectedBank?.loading}
                  onClick={handleProceed}
                >
                  {selectedBank?.loading ? (
                    <Spin
                      spinning={selectedBank?.loading}
                      className="h-100 w-100 align-items-center d-flex justify-content-center"
                    ></Spin>
                  ) : (
                    'Proceed'
                  )}
                </button>
              </div>
            ) : (
              <>
                <div className="d-flex justify-content-center">
                  <PlaidLink
                    token={plaidState.linkToken}
                    onSuccess={handlePlaidSuccess}
                    onExit={handlePlaidExit}
                    className="addMore btn btn-primary rounded-pill btn-lg w-100"
                  >
                    <FormattedMessage id="add.more.bank" />
                  </PlaidLink>
                </div>
                {/* </BlueButton> */}
              </>
            )}
            {bankName.length === 0 && (
              <div className="btnAction mt-4">
                <PlaidLink
                  token={plaidState.linkToken}
                  onSuccess={handlePlaidSuccess}
                  onExit={handlePlaidExit}
                  className=""
                >
                  <span onClick={handleAddMoreBanks}>Add Bank</span>
                </PlaidLink>
              </div>
            )}
          </div>
        </div>
      </Spin>
    </>
  );
};

export default CompanyPlaidComponent;
